// frontend/src/components/landing/sections/ThreeSteps.js
import React from 'react';
import { Box, Typography } from '@mui/material';
import { Container, Reveal, Section, TiltCard } from '../parts';
import { ChartIcon, LabelIcon, UploadIcon } from '../icons';
import { tokens } from '../landingTheme';

const STEPS = [
    {
        title: 'Upload a transcript',
        body: 'A CSV with one row per utterance and who said it. Your lessons stay in your account, inside a secured, access-controlled deployment.',
        Icon: UploadIcon,
    },
    {
        title: 'Every utterance is labelled',
        body: 'A classifier trained on expert-coded science lessons reads each utterance with the talk around it and assigns its utterance type and reasoning component.',
        Icon: LabelIcon,
    },
    {
        title: 'Explore the lesson',
        body: 'Code distributions, the teacher / student balance, a timeline, interaction patterns, frequent sequences and the mix of reasoning across the lesson. Export as JSON or CSV.',
        Icon: ChartIcon,
    },
];

// Three cards, each with an icon tile and its step number
const ThreeSteps = () => (
    <Section id="how-it-works" aria-labelledby="how-it-works-title">
        <Container>
            <Reveal sx={{ textAlign: 'center' }}>
                <Typography variant="overline" component="p" sx={{ color: tokens.accent }}>
                    How it works
                </Typography>
                <Typography id="how-it-works-title" variant="h2" component="h2" sx={{ mt: 1.5, maxWidth: '18ch', mx: 'auto' }}>
                    From transcript to insight in three steps
                </Typography>
            </Reveal>
            <Box
                component="ol"
                sx={{
                    listStyle: 'none',
                    m: 0,
                    p: 0,
                    mt: { xs: 6, md: 8 },
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
                    gap: 3,
                }}
            >
                {STEPS.map(({ title, body, Icon }, i) => (
                    <Reveal component="li" key={title} delay={i * 120}>
                        <TiltCard sx={{ p: { xs: 3, md: 4 }, height: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Box
                                    aria-hidden="true"
                                    className="card-tile"
                                    sx={{ width: 52, height: 52, borderRadius: 4, display: 'grid', placeItems: 'center', bgcolor: tokens.accentTint, color: tokens.accent }}
                                >
                                    <Icon size={24} />
                                </Box>
                                <Typography
                                    aria-hidden="true"
                                    sx={{ fontFamily: tokens.display, fontWeight: 700, fontSize: '0.875rem', color: tokens.inkMuted }}
                                >
                                    Step {i + 1}
                                </Typography>
                            </Box>
                            <Typography variant="h3" component="h3" sx={{ mt: 4 }}>
                                {title}
                            </Typography>
                            <Typography variant="body1" sx={{ mt: 1.5, color: tokens.inkMuted }}>
                                {body}
                            </Typography>
                        </TiltCard>
                    </Reveal>
                ))}
            </Box>
        </Container>
    </Section>
);

export default ThreeSteps;
